import { Box, Card, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HttpServices from 'src/services/httpService';
import { postsModuleURL } from 'src/services/urlService';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import FacebookPreview from './FacebookPreview/facebook-preview.component';
import GoogleMyBusinessPreview from './GoogleMyBusinessPreview/gbusiness-preview.component';
import InstagramPreview from './InstagramPreview/instagram-preview.component';
import LinkedinPreview from './LinkedinPreview/linkedin-preview.component';
import PinterestPreview from './PinterestPreview/pinterest-preview.component';
import TikTokPreview from './TiktokPreview/tiktok-perview-component';
import TwitterPreview from './TwitterPreview/twitter-preview.component';
import YoutubePreview from './YoutubePreview/youtube-preview.component';
import ThreadsPreview from './ThreadsPreview/threads-preview.component';
import BlueskyPreview from './BlueskyPreview/bluesky-preview.component';
import SnapchatPreview from './SnapchatPreview/snapchat-perview-component';

const PostPreview = ({ postDetails, isOrgEvent = false }) => {
  const { t: translate } = useTranslation();
  const { showToast } = useToaster();
  const [scheduleEventInfo, setScheduleEventInfo] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    getScheduledPost();
  }, []);

  const getScheduledPost = () => {
    const postId = postDetails?.data?.id;
    let getProps = {
      url: isOrgEvent
        ? `${postsModuleURL.orgScheduledEventInfo}${postId}&type=PostPreview`
        : `${postsModuleURL.scheduledEventInfo}${postId}`,
      successCallback: postSuccessCallback,
      failureCallback,
    };
    HttpServices.Get(getProps);
  };

  const postSuccessCallback = (data, message) => {
    message && showToast(message, 's');
    setScheduleEventInfo(data);
    setLoader(false);
  };
  const failureCallback = (message) => {
    message && showToast(message, 'e');
    setLoader(false);
  };

  return (
    <Box>
      {loader ? (
        <Spinner />
      ) : (
        <Card style={{ marginLeft: '1rem' }}>
          <Typography variant="h5" gutterBottom sx={{ p: 1 }}>
            {translate('approval.tab.preview_event.title')}
          </Typography>
          {scheduleEventInfo?.scheduled_event_requests_data && (
            <Card>
              <FacebookPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.facebook_requests_data}
                isOrgEvent={isOrgEvent}
              ></FacebookPreview>
              <InstagramPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.instagram_requests_data}
                isOrgEvent={isOrgEvent}
              ></InstagramPreview>
              <TwitterPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.twitter_requests_data}
                isOrgEvent={isOrgEvent}
              ></TwitterPreview>
              <ThreadsPreview
               postDetails={scheduleEventInfo.scheduled_event_requests_data.threads_requests_data}
                isOrgEvent={isOrgEvent}
              ></ThreadsPreview>  
              <YoutubePreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.youtube_requests_data}
                isOrgEvent={isOrgEvent}
              ></YoutubePreview>
              <LinkedinPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.linkedin_requests_data}
                isOrgEvent={isOrgEvent}
              ></LinkedinPreview>
              <GoogleMyBusinessPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.gbusiness_requests_data}
                isOrgEvent={isOrgEvent}
              ></GoogleMyBusinessPreview>
              <TikTokPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.tiktok_requests_data}
                isOrgEvent={isOrgEvent}
              ></TikTokPreview>
              <PinterestPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.pinterest_requests_data}
                isOrgEvent={isOrgEvent}
              ></PinterestPreview>
              <BlueskyPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.bluesky_requests_data}
                isOrgEvent={isOrgEvent}
              ></BlueskyPreview>
              <SnapchatPreview
                postDetails={scheduleEventInfo.scheduled_event_requests_data.snapchat_requests_data}
                isOrgEvent={isOrgEvent}
              ></SnapchatPreview>
            </Card>
          )}
        </Card>
      )}
    </Box>
  );
};

export default PostPreview;
